import { useRef } from 'react';

import { generateElementId } from '../../utils/id/generate-element-id';

export default function useId(id?: string, prefix?: string) {
   const idRef = useRef(generateElementId(prefix));
   return id || idRef.current;
}
